module.exports = __webpack_public_path__ + "static/media/vividStyle.b7c38451.gif";